import {
    // FILE_UPLOAD,
    CREATE_CQCORGANIZATIONREREGISTRATION,
    RETRIEVE_CQCORGANIZATIONREREGISTRATION,
    RETRIEVESINGLE_CQCORGANIZATIONREREGISTRATION,
    UPDATE_CQCORGANIZATIONREREGISTRATION,
    DELETE_CQCORGANIZATIONREREGISTRATION,
} from "./type";
import OrganisationReregistration from "../service/OrganisationReregistration";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await OrganisationReregistration.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await OrganisationReregistration.create(data);
        dispatch({
            type: CREATE_CQCORGANIZATIONREREGISTRATION,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await OrganisationReregistration.fetchList(data);
        dispatch({
            type: RETRIEVE_CQCORGANIZATIONREREGISTRATION,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await OrganisationReregistration.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_CQCORGANIZATIONREREGISTRATION,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await OrganisationReregistration.update(data);
        dispatch({
            type: UPDATE_CQCORGANIZATIONREREGISTRATION,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await OrganisationReregistration.changeStatus(data);
//         dispatch({
//             type: UPDATE_CQCORGANIZATIONREREGISTRATION,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await OrganisationReregistration.trash(data);
        dispatch({
            type: DELETE_CQCORGANIZATIONREREGISTRATION,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};